import axios from 'axios'
const setCookie = (name, value, maxAge) => {
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(JSON.stringify(value))};max-age=${maxAge};path=/`
}
export default {
  SET_AUTH: (state, auth) => {
    state.auth = auth
    if (!auth) {
      axios.defaults.headers.common = {}
      setCookie('token', '', -1)
      setCookie('user', '', -1)
    }
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    axios.defaults.headers.common = {'Authorization': token}
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_USER: (state, user) => {
    state.user = user
  },
  SET_COOKIE_TOKEN: (state, token) => {
    state.token = token
    setCookie('token', token, 43200)
    axios.defaults.headers.common = {'Authorization': token}
  },
  SET_COOKIE_USER: (state, user) => {
    state.user = user
    setCookie('user', user, 43200)
  },
  SET_USER_LOGO: (state, logo) => {
    state.user.avatar = logo
    setCookie('user', state.user, 43200)
  },
  SET_COMPANY_LOGO: (state, logo) => {
    state.user.company.logo = logo
    state.user.company.logo_id = logo?._id
    setCookie('user', state.user, 43200)
  },
  SET_COMPANY_NAME: (state, name) => {
    state.user.company.name = name
    setCookie('user', state.user, 43200)
  },
  SET_COMPANY_DATA: (state, data) => {
    state.user.company.name = data.name
    state.user.company.email = data.email
    state.user.company.inn = data.inn
    state.user.company.kpp =  data.kpp
    setCookie('user', state.user, 43200)
  }
}